module.exports = __webpack_public_path__ + "img/authenticationError.7fc632d9.png";